import { useParams } from "react-router-dom";
import { PATH_DASHBOARD } from "../routes/paths";

export const useEventRelativeLink = () => {
    const { subId, eventId } = useParams()
    return PATH_DASHBOARD.sub.event.view.root(subId, eventId)
}